export default __webpack_public_path__ + "static/media/Kannada_education_f.d4d42621.wav";